import { render, staticRenderFns } from "./NofViewsSelector.vue?vue&type=template&id=d2589d36&"
import script from "./NofViewsSelector.vue?vue&type=script&lang=js&"
export * from "./NofViewsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports